import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import VocabularyThemeForm from './VocabularyThemeForm';
import VocabularyThemeFormService from '../services/VocabularyThemeFormService';

class VocabularyThemeFormContainer extends Component {
  static propTypes = {
    vocabularyThemeId: PropTypes.string,
  };

  static defaultProps = {
    vocabularyThemeId: null,
  };

  vocabularyThemeFormService = new VocabularyThemeFormService();
  componentWillMount() {
    this.vocabularyThemeFormService.handleLoad(this.props.vocabularyThemeId);
  }

  render() {
    return (
      <VocabularyThemeForm
        onSubmit={this.vocabularyThemeFormService.handleSubmit}
        onChange={this.vocabularyThemeFormService.form.setValue}
        onReset={this.vocabularyThemeFormService.form.reset}
        values={this.vocabularyThemeFormService.form.getValues()}
        errors={this.vocabularyThemeFormService.form.errors}
        submitting={this.vocabularyThemeFormService.submit.fetching}
        isDirty={this.vocabularyThemeFormService.form.isDirty}
      />
    );
  }
}

export default observer(VocabularyThemeFormContainer);
